import { render, staticRenderFns } from "./reset-phone.vue?vue&type=template&id=32f6071a&scoped=true&"
import script from "./reset-phone.vue?vue&type=script&lang=js&"
export * from "./reset-phone.vue?vue&type=script&lang=js&"
import style0 from "./reset-phone.vue?vue&type=style&index=0&lang=css&"
import style1 from "./reset-phone.vue?vue&type=style&index=1&id=32f6071a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f6071a",
  null
  
)

export default component.exports